"use client";

import getUserCountryFromClient from "@/lib/user-context/getUserCountryFromClient";

export function validateLocation(
  allowedIn: string[],
  blockedIn: string[],
): boolean {
  const userLocation = getUserCountryFromClient() || "US";

  // Filter out "null" string values (used as placeholder for Algolia)
  const filteredAllowedIn = allowedIn.filter((loc) => loc !== "null");
  const filteredBlockedIn = blockedIn.filter((loc) => loc !== "null");

  const isValidLocation =
    (filteredAllowedIn.length === 0 && filteredBlockedIn.length === 0) ||
    ((filteredAllowedIn.includes(userLocation) ||
      filteredAllowedIn.length === 0) &&
      (!filteredBlockedIn.includes(userLocation) ||
        filteredBlockedIn.length === 0));

  return isValidLocation;
}
